<template>
	<div>
		<div class="flex flex-col items-center text-center">
			<ExclamationTriangleIcon class="mb-3 h-8 w-8 text-red-400" />

			<p class="mx-6 mb-2 text-sm font-semibold text-slate-900">
				{{ message }}
			</p>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ExclamationTriangleIcon } from '@heroicons/vue/24/solid'

defineProps<{
	message: String
}>()
</script>
